var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18.5","cy":"18.5","r":"17.5","transform":"rotate(-180 18.5 18.5)","fill":"#FFB699","stroke":"#FF5600","strokeWidth":"2","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.7054 29.9997L7.49111 19.3305L6.73828 18.4588L7.49111 17.5871L16.7054 6.91797L18.724 8.66136L11.4143 17.1253L30 17.1253L30 19.7925L11.4145 19.7925L18.724 28.2563L16.7054 29.9997Z","fill":"#FF5600","key":1})]);
}

ArrowLeft.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
